import { indexData } from '@/mocks/homeData';

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按主题浏览所有争议事件深度报道</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="flex items-center justify-between px-5 py-4 bg-background-100 border border-background-200 rounded-xl hover:border-accent-300 hover:bg-accent-50 transition-all cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200 px-2.5 py-1 rounded-full whitespace-nowrap">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}